import { apiClient } from '../../gateways/api'
import type { Gebiedswissel } from '../types/Gebiedswissel'

export { createGebiedswissel }

const createGebiedswissel = async ({
  gebiedscode,
  lines,
  omschrijving,
}: {
  gebiedscode: string
  lines: string[]
  omschrijving: string
}): Promise<Gebiedswissel> => {
  const { data } = await apiClient({
    url: '/rest/beheer/gebiedswissel',
    method: 'POST',
    data: {
      gebiedscode,
      lines,
      omschrijving,
    },
  })

  return data
}
